import React, { useEffect, useState } from 'react';
import { InputDropdown, InputText } from 'components';
import './style.scss';
import { Dropdown, Modal } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import GoogleMap from './GoogleMap';
import { AdminService } from 'services/AdminService';
import { Notification } from 'components/Notification/Notification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from '@fortawesome/fontawesome-free-solid';

const Store = ({ item }) => {
  return (
    <div className="map-popup__store">
      <div>
        <FontAwesomeIcon
          color="#116bd2"
          icon={faMapMarkerAlt}
          size="1x"
          className="mr-3"
        /> {item.ADDRESS}</div>
      <div>
        <FontAwesomeIcon
          color="#116bd2"
          icon={faPhone}
          size="1x"
          className="mr-3"
        /> {item.MOBILE}</div>
    </div>
  )
}

const MapPopup = ({ isOpenModal, closeModal }) => {
  const [locationList, setLocationList] = useState([]);
  const [listProvinces, setListProvinces] = useState([]);
  const [radius, setRadius] = useState(1000);
  const [locationSelected, setLocationSelected] = useState('');

  const intl = useIntl();

  useEffect(() => {
    getProvinces();
    getStore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProvinces = () => {
    AdminService.getProvinces(res => {
      if (res.error_code === '0') {
        setListProvinces(res.transformList);
      }
    });
  }

  const getStore = () => {
    const data = {
      lat: localStorage.getItem('lat') || '21.019051',
      lng: localStorage.getItem('lng') || '105.809652',
      size: radius
    };

    AdminService.getStoreHomeMobi(data, res => {
      if (res.error_code === "0") {
        setLocationList(res.result);
      } else {
        Notification.error(res.message);
      }
    });
  }

  const getStoreHomeMobiByProvince = (province_id) => {
    const data = {
      province_id
    };

    AdminService.getStoreHomeMobiByProvince(data, res => {
      if (res.error_code === "0") {
        setLocationList(res.result);
      }
    });
  }

  const handleSelectedProvince = (item) => {
    getStoreHomeMobiByProvince(item.id)
  }

  const onSelect = (item, index) => {
    setLocationSelected({ ...item, zoom: 18, index });
  }

  return (
    <Modal show={isOpenModal} onHide={closeModal} className="map-popup" size="lg">
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='IDS_TV_DIA_DIEM_STORE' /></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="map-popup__body">
          <div className="display-sb map-popup__input">
            <InputText
              handleOnChange={(value) => setRadius(value)}
              value={radius}
              onEnter={getStore}
              placeholder={intl.formatMessage({ id: 'IDS_TV_BAN_KINH' })}
              onlyNumber
            />
            <InputDropdown
              list={listProvinces}
              handleOnChange={handleSelectedProvince}
              placeholder={intl.formatMessage({ id: 'IDS_TV_CHON_TINH_TP' })}
            />
            <Dropdown className="map-popup__dropdown">
              <Dropdown.Toggle>{locationList.length} <FormattedMessage id='IDS_TV_CUA_HANG' /></Dropdown.Toggle>
              <Dropdown.Menu>
                {locationList.map((item, index) => (
                  <Dropdown.Item onSelect={() => onSelect(item, index)} key={index}>
                    <Store item={item} />
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <GoogleMap
            locationList={locationList}
            locationSelected={locationSelected}
          />
        </div>
      </Modal.Body>

      {/* <Modal.Footer>
        <div onClick={handleConfirm} className="confirm-btn">Done</div>
      </Modal.Footer> */}
    </Modal>
  );
};

export default React.memo(MapPopup);
